import React from 'react'
import { Link } from 'gatsby'
import { withTheme } from 'styled-components'
import { Box, Image } from 'rebass'
import SearchGroupResultRow from './SearchGroupResultRow'
import CategoryBadge from './CategoryBadge'
import ColumnImage from './ColumnImage'
import ColumnDescription from './ColumnDescription'
import ArrowRight from './ArrowRight'
import highlight from '../../../lib/highlighter'

const SearchResult = ({
  searchTerm,
  category,
  text,
  imageUrl,
  url,
  onClick
}) => {
  return (
    <Link to={url} onClick={onClick}>
      <SearchGroupResultRow>
        <ColumnImage width={[5 / 18, 3 / 12]} px={[0, 0, 13, 22]}>
          {imageUrl ? (
            <Image src={imageUrl} />
          ) : (
            <CategoryBadge px={10} mx={0}>
              {category}
            </CategoryBadge>
          )}
        </ColumnImage>
        <ColumnDescription width={[11 / 18, 8 / 12]} py={20} pr={10}>
          <span
            dangerouslySetInnerHTML={{
              __html: highlight(searchTerm, text)
            }}
          />
        </ColumnDescription>
        <Box width={[1 / 18, 1 / 12]}>
          <ArrowRight />
        </Box>
      </SearchGroupResultRow>
    </Link>
  )
}

export default withTheme(SearchResult)
